/**
 * Video player controls
 */
document.querySelectorAll('.vid')?.forEach((vid) => {
	const button = vid.firstElementChild;
	const video = button.nextElementSibling;
	button.addEventListener('click', () => {
		if (!button.classList.contains('playing')) {
			video.addEventListener('loadeddata', () => {
				button.classList.add('playing');
			});
			video.src = video.dataset.src;
			video.load();
			video.play();
		} else {
			video.pause();
			video.currentTime = 0;
			button.classList.remove('playing');
		}
	});
	video.addEventListener('ended', () => {
		setTimeout(() => {
			button.classList.remove('playing');
		}, 300);
	});
});
